<template>
    <div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="loading">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Loading, please wait
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
              <div class="mb-3 align-right">
                <a class="btn-primary" :href="`/company/${company.id}/users`">
                  Users
                </a>
                <a class="btn-primary" :href="`/company/${company.id}/address`">
                  Addresses
                </a>
                <a class="btn-primary" :href="`/company/${company.id}/showroom`">
                  Showrooms
                </a>
                <a class="btn-primary" :href="`/company/${company.id}/areas-supplied`">
                  Areas Supplied
                </a>
                <a class="btn-primary mr-1" :href="`/company/${company.id}/notes`">
                  Notes
                </a>
              </div>
                <form method="POST" action="/company/update" id="update_company_form">
                    <input type="hidden" name="_token" v-model="csrfToken">
                    <input type="hidden" name="company_id" v-model="company.id">
                    <input type="hidden" name="new_logo_url" v-model="uploaded_filename">
                    <template v-for="selected_company in selected_companies">
                        <input type="checkbox" v-model="selected_companies" name="linked_companies[]" :value="selected_company" class="hide">
                    </template>
                    <div class="flex-xs">
                        <div class="half-width-xs pr-3-xs">
                          <div class="form-group" v-show="logged_in_user.isStaff">
                            <label>Company Type</label>
                            <select name="company_type_id" v-model="company.company_type_id" class="form-control">
                              <option :value="null" disabled>
                                Please Select ...
                              </option>
                              <option :value="company_type.id" v-for="company_type in company_types">
                                {{ company_type.label }}
                              </option>
                            </select>
                          </div>
                            <div class="form-group">
                                <label>Account Code</label>
                                <input type="text" name="account_code" v-model="company.account_code" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label>Company Name</label>
                                <input type="text" name="name" v-model="company.name" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label>Phone Number</label>
                                <input type="text" name="phone" v-model="company.phone" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label>Fax</label>
                                <input type="text" name="fax" v-model="company.fax" class="form-control">
                            </div>
                          <div class="form-group" v-show="logged_in_user.isStaff">
                            <label class="mb-2">Epwin Systems</label>
                            <table v-for="system_type in types_for_company" class="table-epwin-systems-for-user">
                              <tr>
                                <td class="system">
                                  <div class="checkbox">
                                    <label>
                                      <input type="checkbox"
                                             :name="`epwin_system_types[${system_type.id}][active_for_company]`"
                                             v-model="system_type.active_for_company"
                                             :value="system_type.active_for_company"
                                      >
                                      <span class="checkbox-label">{{ system_type.label }}</span>
                                    </label>
                                  </div>
                                </td>
                                <td class="acp">
                                  <div class="checkbox" v-if="system_type.active_for_company && system_type.acp">
                                    <label>
                                      <input type="checkbox"
                                             :name="`epwin_system_types[${system_type.id}][acp_status]`"
                                             v-model="system_type.acp_status"
                                             :value="system_type.acp_status"
                                      >
                                      <span class="checkbox-label">ACP</span>
                                    </label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2" v-show="system_type.active_for_company && (company.company_type_id !== 1 && company.company_type_id !== 6 && company.company_type_id !== null)">
                                  <div class="form-group mb-0">
                                    <label>
                                      From these fabricators:
                                    </label>
                                    <input type="text"
                                           class="form-control"
                                           :name="`epwin_system_types[${system_type.id}][from_who]`"
                                           v-model="system_type.from_who"
                                    >
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div class="form-group" v-if="company.company_type_id !== 1 && company.company_type_id !== 6 && company.company_type_id !== null">
                            <label>Soffits, facias and trims from:</label>
                            <input type="text" name="soffits_facias_and_trims_from_who" v-model="company.soffits_facias_and_trims_from_who" class="form-control">
                          </div>
                          <div class="form-group">
                            <label>Trade Counter:</label>
                            <select class="form-control" name="which_trade_counter" v-model="company.which_trade_counter">
                              <option value="" disabled>Please Select ...</option>
                              <option value="None">None</option>
                              <option value="Magden">Magden</option>
                              <option value="National Plastics">National Plastics</option>
                              <option value="Nu Stock">Nu Stock</option>
                              <option value="PBS">PBS</option>
                              <option value="Quay">Quay</option>
                              <option value="Saltire">Saltire</option>
                              <option value="SBS">SBS</option>
                              <option value="Shepherds">Shepherds</option>
                              <option value="Venture">Venture</option>
                              <option value="The Window Store">The Window Store</option>
                              <option value="Accrington Plastics">Accrington Plastics</option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                          <div class="form-group" v-if="company.which_trade_counter === 'Other'">
                            <label>Please Specify:</label>
                            <input type="text" class="form-control" name="which_trade_counter_other" v-model="company.which_trade_counter_other">
                          </div>
                        </div>
                        <div class="half-width-xs pl-3-xs">
                            <div class="form-group">
                                <label>X (Twitter)</label>
                                <input type="text" name="twitter" v-model="company.twitter" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Instagram</label>
                                <input type="text" name="instagram" v-model="company.instagram" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Facebook</label>
                                <input type="text" name="facebook" v-model="company.facebook" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Linkedin</label>
                                <input type="text" name="linkedin" v-model="company.linkedin" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Website</label>
                                <input type="text" name="website" v-model="company.website" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Software</label>
                                <input type="text" name="software" v-model="company.software" class="form-control">
                            </div>
                            <div class="flex-lg">
                                <div class="half-width-lg pr-3-lg">
                                    <div class="form-group mb-0 full-height flex flex-col">
                                        <label>Upload New Logo</label>
                                        <form :action="`${$aws_upload_url}`" method="post"
                                              enctype="multipart/form-data" id="amazon_form">
                                            <input type="hidden" name="policy" :value="aws_policy">
                                            <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                            <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                            <input type="hidden" name="x-amz-date" :value="aws_date">
                                            <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                            <input type="hidden" name="acl" value="private">
                                            <input type="hidden" name="Content-Type" v-model="uploaded_filetype">
                                            <input type="hidden" name="key" v-model="uploaded_filename">
                                        </form>
                                        <vue-dropzone
                                                ref="fileUploadDropzone"
                                                id="dropzone"
                                                :options="dropzoneOptions"
                                                v-on:vdropzone-file-added="fileAddedToDropZone"
                                                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                                :useCustomSlot="true"
                                        >
                                            <div>
                                                <div class="mb-3">
                                                    DRAG AND DROP FILE
                                                </div>
                                                <div class="mb-3">
                                                    OR
                                                </div>
                                                <div>
                                                    <a class="btn-secondary-outline">
                                                        Choose a file
                                                    </a>
                                                </div>
                                            </div>
                                        </vue-dropzone>
                                    </div>
                                </div>
                                <div class="half-width-lg pl-3-lg">
                                    <div class="form-group mb-0" v-if="company.logo_url !== null">
                                        <label>Current Image</label>
                                        <div>
                                            <img :src="`${$aws_bucket_url}${company.logo_url}`" class="ml-a mr-a" style="max-height: 150px;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="!update_company_active">
                        <hr class="mb-6 mt-6">
                        <div class="flex mb-6">
                            <div>
                                <h3 class="txt-primary pr-3" v-if="company.company_type_id == 2">
                                  Companies linked to this Installer:
                                </h3>
                                <h3 class="txt-primary pr-3" v-if="company.company_type_id == 1">
                                  Companies linked to this Fabricator:
                                </h3>
                                <h3 class="txt-primary pr-3" v-if="company.company_type_id == 3">
                                  Companies linked to this Trade Counter:
                                </h3>
                                <h3 class="txt-primary pr-3" v-if="company.company_type_id == 4">
                                  Companies linked to this Company:
                                </h3>
                                <h3 class="txt-primary pr-3" v-if="company.company_type_id == 5">
                                    Companies linked to this Builder:
                                </h3>
                                <h3 class="txt-primary pr-3" v-if="company.company_type_id == 6">
                                  Companies linked to this Trial Company:
                                </h3>
                            </div>
                            <div class="flex flex-col justify-around">
                                <div>
                                    <a class="cursor-pointer" @click="update_company_active = true">
                                        <i class="fal fa-pencil"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <table class="table _lined">
                                <tbody>
                                <tr v-for="(fabricator, index) in company.linked_companies">
                                    <td style="width: 125px;">
                                        {{ fabricator.account_code }}
                                    </td>
                                    <td>
                                        {{ fabricator.name }}
                                    </td>
                                    <td class="align-right" style="width: 40px;">
                                        <a :href='"/company/"+fabricator.id' class="txt-primary pl-3">
                                            <i class="fa fa-eye"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                    <template v-if="update_company_active">
                        <hr class="mb-6 mt-6">
                        <div class="flex-xs mb-6">
                            <div>
                              <h3 class="txt-primary pr-3" v-if="company.company_type_id == 2">
                                Select which companies link to this Installer:
                              </h3>
                              <h3 class="txt-primary pr-3" v-if="company.company_type_id == 1">
                                Select which companies link to this Fabricator:
                              </h3>
                              <h3 class="txt-primary pr-3" v-if="company.company_type_id == 3">
                                Select which companies link to this Trade Counter:
                              </h3>
                              <h3 class="txt-primary pr-3" v-if="company.company_type_id == 4">
                                Select which companies link to this Company:
                              </h3>
                                <h3 class="txt-primary pr-3" v-if="company.company_type_id == 5">
                                    Select which companies link to this Builder:
                                </h3>
                            </div>
                            <div class="flex justify-end ml-a">
                                <div class="pr-3">
                                    <a class="btn-danger" @click="update_company_active = false">
                                        Cancel
                                    </a>
                                </div>
                                <div>
                                    <input type="text" placeholder="Search" class="form-control" v-model="companies_search_query">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <table class="table _lined">
                                <tbody>
                                <tr v-for="(company, index) in linkable_companies">
                                    <td style="width: 40px;">
                                        <input type="checkbox" v-model="selected_companies" :value="company.id" :id="`company_${company.id}`">
                                    </td>
                                    <td style="width: 125px;">
                                        <label :for="`company_${company.id}`">
                                            {{ company.account_code }}
                                        </label>
                                    </td>
                                    <td>
                                        <label :for="`company_${company.id}`">
                                            {{ company.name }}
                                        </label>
                                    </td>
                                    <td>
                                      <label :for="`company_${company.id}`">
                                        {{ company.company_type.label }}
                                      </label>
                                    </td>
                                    <td class="align-right" style="width: 40px;">
                                        <a :href='"/company/"+company.id' class="txt-primary pl-3">
                                            <i class="fa fa-eye"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <template>
                                <div class="pagination-bar wrapper mb-3 mt-3">
                                    <div class="row">
                                        <div class="col">
                                            <a @click.prevent="prevCompaniesPage()" v-if="current_companies_page > 1" class="btn-default _sm"><i
                                                    class="fa fa-caret-left"></i></a>
                                            <a class="btn-default _sm">{{ current_companies_page }} / {{ total_companies_pages }}</a>
                                            <a @click.prevent="nextCompaniesPage()" v-if="current_companies_page < total_companies_pages"
                                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                                        </div>
                                        <div class="col align-right">
                                            <div class="mt-1 mb-1">
                                                {{ total_companies_count }} results found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <div class="align-right mt-3">
                        <button type="submit" @click.stop.prevent="save()" class="btn-primary">
                            Update Company
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone';

export default {
    props: [
      'prop_company',
      'logged_in_user',
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature',
      'epwin_system_types_for_company',
      'linked_companies',
      'company_types',
    ],
    components: {
      'vue-dropzone': vue2Dropzone,
    },
    mounted() {
      this.loadLinkableCompanies();
      this.selected_companies = this.linked_companies;

      if(!this.trade_counter_types.includes(this.company.which_trade_counter)) {
        this.company.which_trade_counter_other = this.company.which_trade_counter;
        this.company.which_trade_counter = 'Other';
      }
    },
    data() {
        return {
          trade_counter_types: [
            'None',
            'Magden',
            'National Plastics',
            'Nu Stock',
            'PBS',
            'Quay',
            'Saltire',
            'SBS',
            'Shepherds',
            'Venture',
            'The Window Store',
            'Accrington Plastics',
          ],
          company: this.prop_company,
          loading: true,
          saving: false,
          csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          types_for_company: this.epwin_system_types_for_company,
          uploaded_filetype: '',
          uploaded_file: null,
          uploaded_filename: null,
          dropzoneOptions: {
            url: '/',
            autoProcessQueue: false,
            uploadMultiple: true,
            addRemoveLinks: true,
          },
          linkable_companies: [],
          selected_companies: [],
          companies_search_query: null,
          current_companies_page: 1,
          total_companies_count: 0,
          total_companies_pages: 0,
          companies_limit: 20,
          update_company_active: false,
        }
    },
    methods: {
      loadLinkableCompanies: _.debounce(function () {
        let linkable_company_type_ids = [1,2,3,4,5,6];

        axios.post('/company/loadLinkableCompanies', {
          company_type_ids: linkable_company_type_ids,
          page_number: this.current_companies_page,
          search_query: this.companies_search_query,
          limit: this.companies_limit,
        }).then((response) => {
          this.linkable_companies = response.data.data;
          this.total_companies_count = response.data.total;
          this.total_companies_pages = response.data.last_page;
          this.loading = false;
        });
      }, 250),
      prevCompaniesPage() {
        this.current_companies_page = this.current_companies_page - 1;
        this.loadLinkableCompanies();
      },
      nextCompaniesPage() {
        this.current_companies_page = this.current_companies_page + 1;
        this.loadLinkableCompanies();
      },
      fileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');

        const allowed_extensions = [
          'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp',
        ];

        if(!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: \'jpg\', \'jpeg\', \'png\',  \'svg\', \'gif\', \'bmp\','
          });
          return;
        }

        if (this.$refs.fileUploadDropzone.dropzone.files.length > 1) {
          this.$refs.fileUploadDropzone.dropzone.removeFile(this.$refs.fileUploadDropzone.dropzone.files[0]);
        }

        const filename = 'company_logos/' + Date.now();
        this.uploaded_filename = filename + '.' + extension;

        this.uploaded_filetype = uploadedFile.type;
        this.uploaded_file = uploadedFile;
      },
      fileRemovedFromDropZone(file) {
        this.uploaded_file = null;
        this.uploaded_filename = null;
        this.uploaded_filetype = null;
      },
      save() {
        this.saving = true;
        const validationErrors = Validate({
          name: this.company.name,
          account_code: this.company.account_code,
        }, {
          name: {
            presence: {
              allowEmpty: false,
            },
          },
          account_code: {
            presence: {
              allowEmpty: false,
            },
          },
        });

        if (validationErrors) {
          this.saving = false;
          Swal.fire({
            title: 'Unable to save company',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        if((this.company.which_trade_counter === null || this.company.which_trade_counter === '') || (this.company.which_trade_counter === 'Other' && (!this.company.which_trade_counter_other || this.company.which_trade_counter_other === '' || this.company.which_trade_counter_other === null))) {
          this.saving = false;
          Swal.fire({
            title: 'Unable to save company',
            icon: 'error',
            text: 'Please select which trade counter this company buys from',
          });
          return;
        }

        if(this.uploaded_file !== null) {
          let form_data = new FormData(document.querySelector('#amazon_form'));
          form_data.append('file', this.uploaded_file);
          axios({
            method: 'post',
            url: this.$aws_upload_url,
            data: form_data,
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then(() => {
            document.getElementById('update_company_form').submit();
          });
        } else {
          document.getElementById('update_company_form').submit();
        }

      },
    },
    watch: {
      companies_search_query() {
        this.current_companies_page = 1;
        this.loadLinkableCompanies();
      },
    },
};
</script>
